import React, {useState, useEffect, useRef} from 'react'
import DataView from '../../../../UI/Dashboard/DataView'
import Ajax from '../../../../../helpers/Ajax'
import { useParams } from 'react-router-dom'
import FormGroup from '../../../../UI/Form/FormGroup'
import ErrorField from '../../../../UI/Form/ErrorField'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import DataLoader from '../../../../UI/Dashboard/DataLoader'
import Button from '../../../../UI/Form/Button'
import ContentLayout from '../../../../Common/ContentLayout'
import { toast } from 'react-toastify'
import { Helmet } from 'react-helmet-async'
import UploadFile from '../../../../../helpers/UploadFile'
export default function AmenityDetail() {
    const [infoDetail, setInfoDetail] = useState(null)
    const [mobileImage, setMobileImage] = useState("")
    const urlParams = useParams()
    const dataIcon = useRef()
    useEffect(()=>{
        const getResponse = setTimeout(function(){
            (async()=>{
              const response = await Ajax({
                url: `/amenities?_id=${urlParams.AmenityId}`,
                token: true
              })
              if(response.data.status === "SUCCESS!"){
                setInfoDetail(response.data.result[0])
                setMobileImage(response.data.result[0]?.mobileFile)
              }
            })()
          },100)
      
          return()=>{
            clearInterval(getResponse)
          }
    },[])

    async function uploadImage(e){
        const imageUrl = await UploadFile(e)
        setMobileImage(imageUrl)
    }

    const updateProcess = async (values, event) => {
        const formData = new FormData()
        if(dataIcon.current.value != ''){
            formData.append("file", dataIcon.current.files[0])
        }
        const data = {
            name: values.amenity_title, 
            active: values.active == 1 ? true : false, 
            mobileFile: mobileImage
        }
        for(var key in data) {
            if(data[key] !== "") {
                formData.append(key, data[key])
            }
        }
        const update = await Ajax({
            url: `/amenities/${urlParams.AmenityId}`,
            method: 'PUT',
            token: true,
            data: formData,
            loader: true
        })
        if(update.error){
            toast.error('Something Went Wrong Please Check')
        }
        if(update.data.status === "SUCCESS!"){
            toast.success('Content Updated Successfully')
            setTimeout(function(){
                window.location.reload()
            },500)
        }
    }
    return (
        <ContentLayout title="Amenity Detail">
            <Helmet>
                <title>Amenity Detail</title>
            </Helmet>
            <DataView title="Infomation">
            {infoDetail === null ? <DataLoader/> : 
                <Formik
                    initialValues={{ 
                        amenity_title: infoDetail.name ? infoDetail.name : '', 
                        active: infoDetail.active === true ? 1 : 2
                    }}
                    validationSchema={Yup.object({
                        amenity_title: Yup.string()
                        .required('Field is Required'),
                        active: Yup.string()
                        .required('Field is Required')
                    })}
                    onSubmit={(values, event) => {
                        updateProcess(values, event)
                    }}
                >
                <Form>
                    <div className='row'>
                        <div className='col-md-6'>
                            <FormGroup label="Amenity Title" required>
                                <Field placeholder='Amenity Title' name="amenity_title" className='form-control' />
                                <ErrorField><ErrorMessage name="amenity_title"/></ErrorField>
                            </FormGroup>
                        </div>
                        <div className='col-md-4'>
                            <FormGroup label="Amenity Image" required>
                                <input type="file" accept='.jpg, .png, jpeg, .webp' name="amenity_image" ref={dataIcon} className='form-control' />
                            </FormGroup>
                        </div>
                        <div className='col-md-2'>
                            {infoDetail.file && 
                            <FormGroup label="Preview">
                                <img src={infoDetail.file.path} alt="prcess icon" width="80px" className='img-fluid' /> 
                            </FormGroup>}
                        </div>
                        <div className='col-md-6'>
                            <FormGroup label="Amenity Mobile Image">
                                 <input type="file" name="mobileFile" className='form-control' onChange={uploadImage}/>
                            </FormGroup>
                        </div>
                        <div className='col-md-6'>
                            {mobileImage && 
                            <FormGroup label="Preview">
                                <img src={mobileImage} alt="prcess icon" width="80px" className='img-fluid' /> 
                            </FormGroup>}
                        </div>
                    </div>
                    <FormGroup label="Active" required>
                        <Field as="select" name="active" className='form-select'>
                            <option value="1">Enable</option>
                            <option value="2">Disable</option>
                        </Field>
                        <ErrorField><ErrorMessage name="type"/></ErrorField>
                    </FormGroup>
                    <div className='col-md-2 d-grid'>
                        <Button type="submit">Update</Button>
                    </div>
                </Form>
                </Formik> }
            </DataView>
        </ContentLayout>
    )
}
